import { PropsWithChildren } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { usePageView } from "@analytics/hooks/usePageView";

import SignupSuccess from "@components/SignupSuccess";

import ViewCampaign from "@pages/Campaigns/ViewCampaign";
import Index from "@pages/Companies";
import LogIn from "@pages/LogIn";
import Organization from "@pages/Organizations";
import PasswordReset from "@pages/PasswordReset";
import Portfolio from "@pages/Portfolio";
import SignUp from "@pages/SignUp";
import Technology from "@pages/Technology";
import VerifyEmail from "@pages/VerifyEmail";

import { useUserStore } from "@store/userStore";

import AppLoader from "./AppLoader";
import OrganizationRouteMiddleware from "./middleware/organizations.middleware"; // The middleware wrapper
import CreateCampaign from "./pages/CreateCampaign";
import NylasCallback from "./pages/NylasCallback";

function PublicRoute({
  children, // Element to Render
}: PropsWithChildren) {
  const authenticated = useUserStore((state) => state.authenticated);

  return authenticated ? <Navigate to="/ip-search" /> : <>{children}</>;
}

function Router() {
  usePageView();
  return (
    <Routes>
      {/* Public Routes ==================================================================== */}
      <Route
        element={
          <PublicRoute>
            <LogIn />
          </PublicRoute>
        }
        path="/login"
      />
      <Route
        element={
          <PublicRoute>
            <SignUp />
          </PublicRoute>
        }
        path="/signup"
      />
      <Route
        element={
          <PublicRoute>
            <PasswordReset />
          </PublicRoute>
        }
        path="/password-reset/:token"
      />
      <Route
        element={
          <PublicRoute>
            <VerifyEmail />
          </PublicRoute>
        }
        path="/verify-email/:token"
      />
      {/* Private Routes ==================================================================== */}
      <Route element={<AppLoader />}>
        <Route element={<Index />} path="/smart-search/*" />
        <Route element={<Portfolio />} path="/portfolio" />
        <Route
          element={
            <OrganizationRouteMiddleware redirectTo="/portfolio">
              <Organization />
            </OrganizationRouteMiddleware>
          }
          path="/organization/:organizationId"
        />
        <Route element={<Technology />} path="/portfolio/technology/:technologyId/*" />
        <Route element={<CreateCampaign />} path="/campaigns/create/:campaignId/*" />
        <Route element={<ViewCampaign />} path="/campaigns/:campaignId/*" />
        <Route element={<NylasCallback />} path="/nylas/callback" />
        <Route element={<Navigate to="/smart-search/companies" />} path="*" />
      </Route>
    </Routes>
  );
}

export default Router;
